import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'
import {Box, Typography} from '@mui/material'
import {AlertWithLeftBorder} from '../../../../../Molecules/Alert/AlertWithLeftBorder'
import {useTranslation} from 'react-i18next'

interface Props {
  remaining: number;
}
export const SlotOrderWindowAlert: React.FC<Props> = ({ remaining }) => {

  const {t: translate} = useTranslation()

  const formatTime = (seconds: number): string => {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    const mm = m < 10 ? `0${m}` : `${m}`
    const ss = s < 10 ? `0${s}` : `${s}`
    return `${mm}:${ss}`
  }
  const formatted = formatTime(remaining);
  return (
    <AlertWithLeftBorder
      type="info"
      message={
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16
          }}
        >
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 16
            }}
          >
            <AccessTimeRoundedIcon sx={{color: '#1976d2'}} />
            <Typography
              sx={{
                fontSize: '1rem',
                color: '#0a2540'
              }}
            >
              {translate('orderIntake.rmc.steps.shared.validationErrors.reservationWindowAlertTitle')}
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: '1rem',
              color: '#d32f2f',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            {formatted}
          </Typography>
        </Box>
      }
    />
  )
}
